import React from "react";
import { FiMessageSquare, FiUserCheck, FiSettings } from "react-icons/fi";

export default function Versao19() {
  return (
    <div className="w-full p-6 space-y-6">

      <h1
        className="text-green-700 font-semibold"
        style={{ fontFamily: "Comfortaa, cursive", fontSize: "20px" }}
      >
        Melhorias da Versão 1.0.19
      </h1>

      {/* Item 1 */}
      <div className="flex items-start gap-3">
        <FiMessageSquare className="text-purple-600 mt-1" size={18} />
        <div>
          <p
            className="font-semibold text-gray-800"
            style={{ fontFamily: "Comfortaa, cursive" }}
          >
            Novo Sistema de Mensagens:
          </p>
          <p
            className="text-gray-700"
            style={{ fontFamily: "Comfortaa, cursive" }}
          >
            O módulo de chat foi otimizado para carregar mais rápido e exibir
            mensagens recentes automaticamente ao abrir a conversa.
          </p>
        </div>
      </div>

      {/* Item 2 */}
      <div className="flex items-start gap-3">
        <FiUserCheck className="text-blue-600 mt-1" size={18} />
        <div>
          <p
            className="font-semibold text-gray-800"
            style={{ fontFamily: "Comfortaa, cursive" }}
          >
            Melhorias no Perfil do Usuário:
          </p>
          <p
            className="text-gray-700"
            style={{ fontFamily: "Comfortaa, cursive" }}
          >
            Ajustes visuais no avatar, atualização do layout e correções no
            salvamento automático das preferências.
          </p>
        </div>
      </div>

      {/* Item 3 */}
      <div className="flex items-start gap-3">
        <FiSettings className="text-yellow-600 mt-1" size={18} />
        <div>
          <p
            className="font-semibold text-gray-800"
            style={{ fontFamily: "Comfortaa, cursive" }}
          >
            Ajustes Gerais no Sistema:
          </p>
          <p
            className="text-gray-700"
            style={{ fontFamily: "Comfortaa, cursive" }}
          >
            Correções de pequenos bugs, melhoria no tempo de resposta do painel
            e otimizações internas.
          </p>
        </div>
      </div>

      {/* Caixa Amarela */}
      <div className="border border-yellow-300 bg-yellow-100 p-4 rounded-lg shadow-sm flex items-start gap-3">
        <div className="mt-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="none"
            stroke="#6B7280"
            strokeWidth="1.8"
            className="text-gray-600"
          >
            <path d="M12 9v3m0 3h.01M10.29 3.86L1.82 18h20.36L13.71 3.86a2 2 0 00-3.42 0z" />
          </svg>
        </div>

        <div>
          <p
            className="font-semibold text-gray-800"
            style={{ fontFamily: "Comfortaa, cursive" }}
          >
            Aviso sobre as próximas atualizações
          </p>

          <p
            className="text-gray-700"
            style={{ fontFamily: "Comfortaa, cursive" }}
          >
            A versão 1.0.20 incluirá ajustes finais no sistema de notificações e
            melhorias no desempenho geral.
          </p>
        </div>
      </div>
    </div>
  );
}
